export default __webpack_public_path__ + "static/pcoLaptop-b0043e381fe28f2c21469132b4170940.png";